import { useParams } from "react-router";
import React, { useEffect, useState, FormEvent } from "react";
import Form from "../../../components/common/form/Form";
import {  datePicker } from "../../../helpers/utils/Utils";
import Modal from "../../../components/common/form/Modal";
import TextAreaField from "../../../components/common/form/TextAreaField";
import ButtonTray from "../../../components/common/form/ButtonTray";
import { useCreateToDoTaskMutation, useUpdateToDoTaskMutation } from "../productsApi";


interface ToDoObj {
    id?: string;
    description?: string;
    followUpDate?: string | null;
}

interface AddOrUpdateToDoTaskProps {
    title: string;
    show: boolean;
    setShow: (show: boolean) => void;
    todoObj?: any;
    btnName: string;
}

const AddOrUpdateToDoTask: React.FC<AddOrUpdateToDoTaskProps> = ({ title, show, setShow, todoObj, btnName }) => {
    const { orderId } = useParams<{ orderId: string }>();

    const [description, setDescription] = useState<string>('');
    const [followUpDate, setFollowUpDate] = useState<string | null>(null);
    const [disable, setDisable] = useState<boolean>(false);
    const [createApi, createApiRes] = useCreateToDoTaskMutation();
    const [updateApi, updateApiRes] = useUpdateToDoTaskMutation();

    useEffect(() => {
        if (todoObj !== null) {
            setDescription(todoObj.description ?? "");
            setFollowUpDate(todoObj.followUpDate ?? null);
        }
    }, [todoObj]);

    const toDoDto = {
        description: description,
        orderId: orderId,
        followUpDate: followUpDate ?? null
    };


    function handleSubmit(e: FormEvent) {
        e.preventDefault();
        setDisable(true);

        if (btnName !== "Update") {
            createApi(toDoDto);
        } else if (todoObj?.id) {
            updateApi({
                "toDoId": todoObj.id,
                "obj": toDoDto
            })
        }
        setShow(false)
    }

    return (
        <Modal
            title={title}
            show={show}
            setShow={setShow}
            className={"w-2/5 bg-text-0 text-surface-0"}
            fields={
                <>
                    <Form onSubmit={handleSubmit} fields={
                        <>
                            <div className="modal-body">
                                <div className="row mt-2">
                                    <div className="col-sm-9 mt-2">
                                        <TextAreaField
                                            className="form-control"
                                            value={description}
                                            placeholder="Enter Description...."
                                            rows={3}
                                            name="toDoDescription"
                                            onChange={(e) => setDescription(e.target.value)}
                                            label="Description"
                                        />
                                    </div>
                                </div>
                                <div className=" col-span-12 md:grid md:grid-cols-12 gap-3">
                                    <div className="col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center">
                                        <label>Follow Up Date</label>
                                    </div>

                                    <div className="col-span-9 mt-3">
                                        {datePicker(followUpDate, setFollowUpDate, false)}
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row border-t border-t-surface-5 mt-4 flex justify-end">

                                <ButtonTray
                                    buttons={[
                                        {
                                            buttonProps: {
                                                btnText: "Cancel",
                                                onClick: () => setShow(false),
                                                type: "cancel",
                                                className: "cm_btn cm_bg"
                                            },
                                            buttonType: "button"
                                        },
                                        {
                                            buttonProps: {
                                                btnText: btnName,
                                                type: "submit",
                                                isLoading: createApiRes.isLoading || updateApiRes.isLoading,
                                                isDisabled: disable,
                                            },
                                            buttonType: "button"
                                        },

                                    ]}
                                    align={"start"}
                                    gap={2}
                                />


                            </div>
                        </>
                    } />
                </>
            }
        />
    );
};

export default AddOrUpdateToDoTask;
